import { render, staticRenderFns } from "./rdeacharts.vue?vue&type=template&id=b48dece0&scoped=true&"
import script from "./rdeacharts.vue?vue&type=script&lang=js&"
export * from "./rdeacharts.vue?vue&type=script&lang=js&"
import style0 from "./rdeacharts.vue?vue&type=style&index=0&id=b48dece0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48dece0",
  null
  
)

export default component.exports